import { Component, inject, TemplateRef } from '@angular/core';
import { ToastService } from './toast-service';

@Component({
  selector: 'app-toasts',
  standalone: false,
  templateUrl: './toasts.component.html'
})
export class ToastsComponent {
  toastService = inject(ToastService);

  showStandard(text: string) {
    this.toastService.show({ text });
  }

  showSuccess(text: string) {
    this.toastService.show({ text, classname: 'bg-success text-light', delay: 10000 });
  }

  showDanger(text: string) {
    this.toastService.show({ text, classname: 'bg-danger text-light', delay: 15000 });
  }

  ngOnDestroy(): void {
    this.toastService.clear();
  }
}
